import { useEffect, useState } from 'react';
import { breakpointValues } from 'modules/breakpoints';
export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        if (typeof window === 'undefined') {
            return undefined;
        }
        const media = window.matchMedia(breakpointValues.md);
        setIsMobile(!media.matches);
        const listener = (query) => {
            setIsMobile(!query.matches);
            return null;
        };
        if (media.addEventListener) {
            media.addEventListener('change', listener);
        }
        else {
            media.addListener(listener);
        }
        return () => {
            if (media.removeEventListener) {
                media.removeEventListener('change', listener);
            }
            else {
                media.removeListener(listener);
            }
        };
    }, []);
    return isMobile;
};
